"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedTrackingAppName = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal, Tabitha Bleil
 */
var TrackingAppName = /*#__PURE__*/function () {
  function TrackingAppName() {
    _classCallCheck(this, TrackingAppName);

    this._appName = "";
  }

  _createClass(TrackingAppName, [{
    key: "appName",
    get: function get() {
      return this._appName;
    },
    set: function set(val) {
      this._appName = val;
    }
  }]);

  return TrackingAppName;
}();

var sharedTrackingAppName = new TrackingAppName();

var getSharedTrackingAppName = function getSharedTrackingAppName() {
  return sharedTrackingAppName;
};

exports.getSharedTrackingAppName = getSharedTrackingAppName;